// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1-qsQ","disabled":"FileBtn_disabled__1Soio","warn":"FileBtn_warn__1Wt1K","fade":"FileBtn_fade__gv3TF"};